import React from "react";
import {cn} from "../../utils/cn";

const Card = React.forwardRef(function Card({interactive = false, className, children, ...props}, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        "bg-white rounded-xl border border-ink-200 shadow-xs",
        interactive && "cursor-pointer transition-shadow duration-fast hover:shadow-sm hover:border-ink-300",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

export const CardHeader = ({className, children, action, title, subtitle, ...props}) => (
  <div className={cn("p-5 border-b border-ink-100 flex items-start justify-between gap-4", className)} {...props}>
    <div className="min-w-0">
      {title && <h3 className="text-base font-semibold text-ink-900">{title}</h3>}
      {subtitle && <p className="text-sm text-ink-500 mt-0.5">{subtitle}</p>}
      {children}
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);

export const CardBody = ({className, children, ...props}) => (
  <div className={cn("p-5", className)} {...props}>
    {children}
  </div>
);

export const CardFooter = ({className, children, ...props}) => (
  <div className={cn("px-5 py-4 border-t border-ink-100 flex items-center justify-end gap-2", className)} {...props}>
    {children}
  </div>
);

export default Card;
